export default __webpack_public_path__ + "static/media/arrow-right-black.0b9e1b58.svg";